module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Italic-4c5350df4db140b4f20082c355ea5fc1.svg";